export default __webpack_public_path__ + "static/media/Path3396.38a0a2f8.svg";